import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { BsArrowLeftSquareFill } from "react-icons/bs";

function ProjectDetails(){
    const {projectSlug} = useParams();
    const [selectedImg, setSelectedImg] = useState(null);
    const navigate = useNavigate();

    const projects = [
        {
            slug: "project-1",
            title: "Project 1",
            description: "Details about Project 1",
            images: [
                ...Array.from({ length: 10 }, (_, i) =>
                    `/img/projects/8/${i + 1}.jpeg`
                ),
            ]
        },
        {
            slug: "project-2",
            title: "Project 2",
            description: "Details about Project 2",
            images: [
                ...Array.from({ length: 3 }, (_, i) =>
                    `/img/projects/9/${i + 1}.jpeg`
                ),
            ]
        },
        {
            slug: "project-3",
            title: "Project 3",
            description: "Details about Project 3",
            images: [
                ...Array.from({ length: 37 }, (_, i) =>
                    `/img/projects/4/${i + 1}.jpeg`
                ),
            ]
        },
        {
            slug: "project-4",
            title: "Project 4",
            description: "Details about Project 4",
            images: [
                ...Array.from({ length: 6 }, (_, i) =>
                    `/img/projects/5/${i + 1}.png`
                ),
            ]
        },
        {
            slug: "project-5",
            title: "Project 5",
            description: "Details about Project 5",
            images: [
                ...Array.from({ length: 4 }, (_, i) =>
                    `/img/projects/6/${i + 1}.jpeg`
                ),
            ]
        },
        {
            slug: "project-6",
            title: "Project 6",
            description: "Details about Project 6",
            images: [
                ...Array.from({ length: 13 }, (_, i) =>
                    `/img/projects/7/${i + 1}.jpeg`
                ),
            ]
        },
        {
            slug: "project-7",
            title: "Project 7",
            description: "Details about Project 7",
            images: [
                ...Array.from({ length: 3 }, (_, i) =>
                    `/img/projects/1/${i + 1}.jpg`
                ), '/img/projects/1/IMG_8551.JPG', '/img/projects/1/IMG_8552.jpg'
            ]
        },
        {
            slug: "project-8",
            title: "Project 8",
            description: "Details about Project 8",
            images: [
                ...Array.from({ length: 7 }, (_, i) =>
                    `/img/projects/2/${i + 1}.JPG`
                ),
            ]
        },
        {
            slug: "project-9",
            title: "Project 9",
            description: "Details about Project 9",
            images: [
                ...Array.from({ length: 20 }, (_, i) =>
                    `/img/projects/3/${i + 1}.JPG`
                )
            ]
        },
    ];

    const project = projects.find(p => p.slug === projectSlug);

    return(
        <div className='page-wrapper'>
            <NavBar/>
            <main>
                <BsArrowLeftSquareFill className='back' onClick={() => navigate('/projects')} size={"2.5rem"}/>
                <h1 style={{textAlign:  'center'}}>{project.title}</h1>
                {/* <p style={{textAlign: 'center'}}>{project.description}</p> */}
                <div className="gallery-grid">
                    {project.images.map((src, index) => (
                        <img key={index} src={src} alt={`${project.title} ${index + 1}`} className="project-image" onClick={() => setSelectedImg(src)}/>
                    ))}
                </div>
                {selectedImg && (
                    <div className='lightbox' onClick={() => setSelectedImg(null)}>
                        <img src={selectedImg} alt="Enlarged image" className='lightbox-img'/>
                    </div>
                )}
                
            </main>
            <Footer/>
        </div>
    )
}

export default ProjectDetails;